import {
  buildSearchAvtoSeoDescription,
  buildSearchMotoSeoDescription,
  buildDealersSeoDescription,
  buildSparePartsSeoDescription,
  buildFirmsSeoDescription,
  buildFirmPageSeoDescription,
  buildSearchCommercialSeoDescription,
} from 'shared/helpers/seoDescription';
import { createdDate } from 'shared/helpers/moment';
import { getCustomParams } from 'shared/helpers/seoTextFinder/seoDataFinder';

/*
my test

*/
const buildSearchDescription = (
  { category, type, make, model, location, motoTitle, yearTitle },
  condition,
  icon,
  transportWho,
  transportWhat,
  t,
) =>
  [
    t('Продажа'),
    condition,
    category || type || motoTitle
      ? `${motoTitle || (type && type.title ? type.title.toLowerCase() : '')} ${category &&
        category.title
          ? category.title.toLowerCase()
          : ''}`
      : transportWho,
    icon,
    make && make.title,
    model && model.title,
    `${location || t('в Украине')}.`,
    t('Удобный поиск по объявлениям поможет Вам быстро и легко купить'),
    category || type
      ? `${type && type.title ? type.title.toLowerCase() : ''} ${category && category.title
          ? category.title.toLowerCase()
          : ''}`
      : transportWhat || '',
    `${yearTitle || ''}${t('по выгодной цене на Автобазаре™.')}`,
  ]
    .filter(i => !!i)
    .join(' ');

const getLocationString = (location, t) =>
  location && location.title ? `${t('в ')} ${location.title}` : t('в Украине');

const buildAddDescriptionByTransportSlug = (slug, t) => {
  let firstSlug = 'автомобилей';
  let secondSlug = 'свое авто';
  switch (slug) {
    case 'avto': {
      firstSlug = 'машину';
      secondSlug = 'авто';
      break;
    }
    case 'moto': {
      firstSlug = 'мотоцикл';
      secondSlug = 'мототехники';
      break;
    }
    case 'avtobus': {
      firstSlug = 'бус';
      secondSlug = 'автобуса';
      break;
    }
    case 'gruzovye': {
      firstSlug = 'грузовик_а';
      secondSlug = 'грузового авто';
      break;
    }
    case 'spetstehnika': {
      firstSlug = 'спецтехнику';
      secondSlug = 'спецтехники';
      break;
    }
    case 'pritsepy': {
      firstSlug = 'прицеп';
      secondSlug = 'прицепа';
      break;
    }
    case 'vodnyi-transport': {
      firstSlug = 'водный транспорт';
      secondSlug = 'водного транспорта';
      break;
    }
    case 'zapchasti': {
      firstSlug = 'запчасти';
      secondSlug = 'автозапчастей';
      break;
    }

    default: {
      break;
    }
  }

  return `${t('Быстро продать')} ${t(firstSlug).toLowerCase()}
  ${t('через интернет на сайте')} АвтоБазар™.
  ${t('Бесплатно разместите объявление о продаже')}
  ${t(secondSlug).toLowerCase()}
  ${t('и его увидят тысячи покупателей со всей Украины')}.`;
};

const getAdvertDate = (hotDate, dateCreated, datePublicated, t) => {
  const date = hotDate || dateCreated || datePublicated;
  return date
    ? `${t('от')} ${createdDate(date, t('от') === 'від' ? 'uk' : 'ru').slice(0, -3)}`
    : '';
};

const getBodyAltAvtoAdvert = (isNew, modification, body, category, t) => {
  // const result =
  //   modification && modification.series && modification.series.title
  //     ? isNew
  //       ? t(modification.series.title).charAt(0).toUpperCase() +
  //         t(modification.series.title).slice(1)
  //       : t(modification.series.title).toLowerCase()
  //     : body && body.title
  //       ? isNew
  //         ? t(body.title).charAt(0).toUpperCase() + t(body.title).slice(1)
  //         : t(body.title).toLowerCase()
  //       : isNew
  //         ? t(category.title).charAt(0).toUpperCase() + category.title.slice(1)
  //         : category && category.title && t(category.title).toLowerCase();

  let result = '';
  if (modification && modification.series && modification.series.title) {
    result = isNew
      ? t(modification.series.title).charAt(0).toUpperCase() + t(modification.series.title).slice(1)
      : t(modification.series.title).toLowerCase();
  } else if (body && body.title) {
    result = isNew
      ? t(body.title).charAt(0).toUpperCase() + t(body.title).slice(1)
      : t(body.title).toLowerCase();
  } else if (category && category.title) {
    result = isNew
      ? t(category.title).charAt(0).toUpperCase() + category.title.slice(1)
      : category && category.title && t(category.title).toLowerCase();
  }
  return result;
};

const DESCRIPTION = {
  HOME: (props, t) => t('SEO_HOME_DESCRIPTION'),

  ADVERT: (
    {
      id,
      make,
      model,
      category,
      year,
      mileage,
      capacity,
      capacityUnit,
      engine,
      gearbox,
      location,
      color,
      body,
      drive,
      price,
      isNew = false,
      dealer = false,
      date_created,
      hot_date,
      date_publicated,
      modification,
      capacityAlt,
      characteristics,
    },
    transportDescriptions = '',
    t,
  ) => {
    if (transportDescriptions == 'авто') {
      const { inCity } = getCustomParams({ city: location && location.title }, t);
      const advertDate = getAdvertDate(hot_date, date_created, date_publicated, t);
      const bodyAltAdvert = getBodyAltAvtoAdvert(isNew, modification, body, category, t);
      const bodyAdvert =
        characteristics &&
        characteristics.category &&
        characteristics.category.title &&
        t(characteristics.category.title);
      const capacityAvto = capacity || (capacityAlt && capacityAlt.title ? capacityAlt.title : '');

      return [
        !isNew ? 'Продам' : t('Купить'),
        isNew && t('новое'),
        t(transportDescriptions),
        !isNew && 'бу',
        make && make.title,
        model && model.title,
        modification && modification.title,
        year && year,
        mileage && `${t('с пробегом')} ${t(mileage).slice(0, -7)} ${t('тыс км')}`,
        [
          location && location.title && inCity,
          isNew && dealer && dealer.title && `${t('в салоне')} ${dealer.title}`,
        ]
          .filter(i => !!i)
          .join(', ')
          .replace(',', '')
          .concat('.'),

        isNew && price && `${t('Цена')} ${price}.`,

        isNew ? '' : 'Продаю',
        [
          [
            (!isNew
              ? (bodyAdvert && bodyAdvert.toLowerCase()) || bodyAltAdvert
              : bodyAdvert || bodyAltAdvert) || (isNew ? t('Легковые') : t('легковые')),
            color && color.title && t(color.title).toLowerCase(),
          ]
            .filter(i => !!i)
            .join(', ')
            .replace(',', '')
            .concat(''),
          [
            engine && engine.title && t(engine.title).toLowerCase(),
            capacityAvto + (capacityAvto && capacityUnit && `${` ${t(capacityUnit)}`}`),
          ]
            .filter(i => !!i)
            .join(', ')
            .replace(/,\s*/g, ' / ')
            .concat(''),

          gearbox && gearbox.title && `${t('коробка')} ${t(gearbox.title).toLowerCase()}`,
          drive && drive.title && `${t(drive.title).toLowerCase()} ${t('привод')}`,
        ]
          .filter(i => !!i)
          .join(', ')
          .replace(/$(, )/, '')
          .concat('.'),

        !isNew && price && `${t('Цена')} ${price}.`,
        id && `${t('Объявление')} ${id}`,

        [!isNew && advertDate].filter(i => !!i).join(', ').replace(/$(, )/, '').concat(' '),
      ]
        .filter(i => !!i)
        .join(' ');
    } else if (
      (transportDescriptions === 'Водный транспорт' && !isNew && dealer && dealer.title) ||
      (transportDescriptions === 'Водный транспорт' && !isNew && dealer && dealer.title)
    ) {
      return [
        t('Купить'),
        t(transportDescriptions),
        make && make.title,
        model && model.title,
        modification && modification.title,
        year,
        `в ${t(location.title)}`,
        dealer && dealer.title && `${t('в автосалоне')} ${dealer.title}`,
        mileage &&
          `${t('с пробегом')} ${t(mileage).slice(0, -7)} ${t('с пробегом') === 'с пробегом'
            ? 'тыс км'
            : 'тис км'}`,
        price && `${t('цена')} ${price}`,
        t('на Автобазаре'),
        id && `${t('Объявление')} ${id}`,
      ]
        .filter(i => !!i)
        .join(' ');
    }

    return [
      t('Продажа'),
      make && make.title,
      model && model.title,
      dealer && dealer.title && `${t('в автосалоне')} ${dealer.title}`,
      `${t('характеристики')}`,
      transportDescriptions && `${t(transportDescriptions)}:`,
      [
        category && category.title && `${t('кузов')}- ${t(category.title).toLowerCase()}`,
        year && `${t('год выпуска')} - ${year}`,
        mileage &&
          `${t('с пробегом')} ${t(mileage).slice(0, -7)} ${t('с пробегом') === 'с пробегом'
            ? 'тыс км'
            : 'тис км'}`,
        capacity &&
          capacityUnit &&
          `${t('объем двигателя')} - ${capacity} ${t(capacityUnit) || capacityUnit}`,
        engine && engine.title && `${t('тип топлива')} - ${t(engine.title).toLowerCase()}`,
        gearbox && gearbox.title && `${t('КПП')} - ${t(gearbox.title).toLowerCase()}`,
        color && color.title && `${t('цвет')} - ${t(color.title).toLowerCase()}`,
      ]
        .filter(i => !!i)
        .join(', ')
        .replace(/$(, )/, '')
        .concat('.'),
      [id && `${t('Объявление')} ${id}`]
        .filter(i => !!i)
        .join(', ')
        .replace(/$(, )/, '')
        .concat(' '),
    ]
      .filter(i => !!i)
      .join(' ');

    // // old
    // [
    // t('Продажа'),
    // make && make.title,
    // model && model.title,
    // dealer && `${t('в автосалоне')} ${dealer}`,
    // `, ${t('характеристики')}`,
    // `${transportDescriptions}:`,
    // [
    //   category && category.title && `${t('кузов')}- ${category.title.toLowerCase()}`,
    //   year && `${t('год выпуска')} - ${year}`,
    //   mileage && `${t('с пробегом')} ${mileage}`,
    //   capacity &&
    //     capacityUnit &&
    //     `${t('объем двигателя')} - ${capacity} ${t(capacityUnit) || capacityUnit}`,
    //   engine && engine.title && `${t('тип топлива')} - ${engine.title.toLowerCase()}`,
    //   gearbox && gearbox.title && `${t('КПП')} - ${gearbox.title.toLowerCase()}`,
    //   color && color.title && `${t('цвет')} - ${color.title.toLowerCase()}`,

    // ]
    //   .filter(i => !!i)
    //   .join(' ')
  },

  //

  SPARE_ADVERT: ({ rubric, sparetype, type, make, model, location, id }, t) =>
    [
      t('Продажа'),
      rubric && rubric.title,
      sparetype && (sparetype.title || '').toLowerCase(),
      (type || make || model) && t('на'),
      type && (type.title || '').toLowerCase(),
      make && make.title,
      model && model.title,
      getLocationString(location, t),
      t('на Автобазаре'),
      [id && `${t('Объявление')} ${id}`]
        .filter(i => !!i)
        .join(', ')
        .replace(/$(, )/, '')
        .concat(' '),
    ]
      .filter(i => !!i)
      .join(' '),
  //

  SEARCH: {
    avto: (data, translate) => buildSearchAvtoSeoDescription(data, translate),
    moto: (data, translate) => buildSearchMotoSeoDescription(data, translate),
    mototsikl: (props, t) =>
      buildSearchDescription(props, t('бу и новых'), '🏍️', t('мотоциклов'), t('мотоцикл'), t),
    commercial: (data, translate) => buildSearchCommercialSeoDescription(data, translate),
  },
  SPARE_PARTS: (data, rubricSlug, t, isRegion) =>
    buildSparePartsSeoDescription(data, rubricSlug, t, isRegion),
  FIRM: (data, t) => buildFirmsSeoDescription(data, t),
  FIRM_PAGE: (title, tab, t, car_drive_countries, transportType, tags, firm) =>
    buildFirmPageSeoDescription(title, tab, t, car_drive_countries, transportType, tags, firm),
  DEALERS: (data, slug, t) => buildDealersSeoDescription(data, slug, t),

  DEALER_PAGE: {
    ADVERTS: ({ dealer, isOfficial = false, makes = [] }, t) =>
      [
        t('Купить автомобиль вы можете у'),
        isOfficial && t('официального'),
        t('дилера'),
        makes
          .map(({ title: make }, i, { length: count }) => `${make}${i !== count - 1 ? ', ' : ''}`)
          .join(''),
        `${t('в Украине')} -`,
        dealer || '',
        t('Все предложения автосалона на Автобазаре'),
      ]
        .filter(i => !!i)
        .join(' '),

    NEWS: (dealer = '', t) =>
      `${t('Самые свежие и актуальные предложения автосалона')} ${dealer} ${t(
        'читайте на АвтоБазаре',
      )}.`,

    ABOUT: (dealer = '', t) =>
      `${t('Узнать актуальную информацию об автосалоне')} ${dealer} ${t('на АвтоБазаре')}`,

    CONTACT: (dealer = '', t) =>
      `${t('Узнать контактную информацию автосалона')} ${dealer}: ${t(
        'адрес, месторасположения на карте, контактные номера телефонов, режим работы - все контакты на АвтоБазаре',
      )}`,
  },

  //

  INVOICE: t => t('Квитанция за оплату на АвтоБазаре'),

  //

  JOURNAL: {
    ALL: t => `${t('Все новости и статьи на Автобазар')}™`,
    NEWS: (t, rubric) =>
      `${t('Все')} ${t(rubric || 'Новости').toLowerCase()} ${t('на Автобазаре')}`,
  },

  //

  SERVICE: {
    CAR_COST_ESTIMATE: t => `${t('Оценка стоимости авто')} ${t('на Автобазаре')}`,
    CAR_DRIVE: t => `${t('Пригон авто')} ${t('на Автобазаре')}`,
    SEARCH_SUBSCRIPTIONS: t => `${t('Подписка на поиск')} ${t('на Автобазаре')}`,
  },

  //

  LOGIN: t => `${t('Авторизация на Автобазар')}™`,

  //

  NOT_FOUND: t => t('Страница не найдена'),

  //

  ADVERT_FORM: {
    ADD: (slug, t) => buildAddDescriptionByTransportSlug(slug, t),
    EDIT: t => t('Форма редактирования объявления на Автобазар'),
  },

  //

  PROFILE: {
    PROFILE: t => t('Профиль пользователя'),
    DIALOGS: t => t('Сообщения пользователя'),
    FAVORITES: t => t('Избранные пользователя'),
    BILLING: t => t('Баланс пользователя'),
    SEARCHES: t => t('Поиски пользователя'),
    ADVERTS: t => t('Объявления пользователя'),
    INSURANCE: t => t('Страховка'),
    SEARCH_SUBSCRIPTIONS: t => t('Подписка на поис'),
  },

  //

  MOBILE_FORM: {
    GEO: t => t('Выбор местоположения'),
    FILTERS: t => t('Выбор по параметрам'),
  },

  STATIC_PAGE: {
    LAW: t => t('Политика конфиденциальности – полезная информация от Автобазар'),
    PUBLIC_CONTRACT: t => t('Публичный договор – полезная информация от Автобазар'),
    INFO_ZAPCHASTI: t => t('Запчасти – полезная информация от Автобазар'),
    HELP: t => t('Помощь – полезная информация от Автобазар'),
    FOR_SERVICES: t => t('Автосервисам – полезная информация от Автобазар'),
    FOR_PRIVATES: t => t('Размещение объявлений – полезная информация от Автобазар'),
    FOR_DEALERS: t => t('Пакет “Бизнес Плюс” – полезная информация от Автобазар'),
    BIZNES_PAKET: t => t('Пакет “Бизнес” – полезная информация от Автобазар'),
    ADVERTISING: t => t('Разместить рекламу – полезная информация от Автобазар'),
    ABOUT: t => t('Что такое автобазар – полезная информация от Автобазар'),
    FAQ: t => t('Часто задаваемые вопросы – полезная информация от Автобазар'),
    ENTRANCE: t => t('Регистрация на avtobazar.ua – полезная информация от Автобазар'),
    TRANSPORT_ADS_RULES: t =>
      t('Правила составления объявлений – полезная информация от Автобазар'),
  },
};

export default DESCRIPTION;



// WEBPACK FOOTER //
// ./src/shared/constants/seoDescriptions.js